import React, { useState } from "react";

export default function RandomGenerator() {
  const [results, setResults] = useState(null);

  const cards = {
    'Legendary': [
      {
      'name':'T-Rex',
      'stat': 'Attack'},
      {
      'name':'Robot-Head',
      'stat': 'Health'
      }],
    'Epic': 
    [
      {
      'name':'Cave Painting',
      'stat': 'Attack'},
      {
      'name':'UAV',
      'stat': 'Attack'
      },
      {
      'name':'Obelisk',
      'stat': 'Health'},
      {
      'name':'Military Radio',
      'stat': 'Health'
      }],
    'Rare': 
    [
      {
      'name':'Trojan Horse',
      'stat': 'Attack'},
      {
      'name':'Red Rose',
      'stat': 'Attack'
      },
      {
      'name':'Sabre Cat Skull',
      'stat': 'Attack'},
      {
      'name':'Gun Powder',
      'stat': 'Attack'
      },
      {
      'name':'Kevlar Thread',
      'stat': 'Health'},
      {
      'name':'Fountain of Life',
      'stat': 'Health'
      },
      {
      'name':'Stem C5',
      'stat': 'Health'
      },
      {
      'name':'Pestle and Mortar',
      'stat': 'Health'
      }
      ],
    'Common': 
    [
      {
      'name':'Combat Dummy',
      'stat': 'Attack'},
      {
      'name':'Vial of Poison',
      'stat': 'Attack'
      },
      {
      'name':'Weights',
      'stat': 'Attack'},
      {
      'name':'Anvil',
      'stat': 'Attack'
      },
      {
      'name':'Target',
      'stat': 'Attack'},
      {
      'name':'Grind Stone',
      'stat': 'Attack'
      },
      {
      'name':'Battle Horn',
      'stat': 'Attack'},
      {
      'name':'War Banner',
      'stat': 'Attack'
      },
      {
      'name':'Ancient Emblem',
      'stat': 'Health'},
      {
      'name':'Furnace',
      'stat': 'Health'
      },
      {
      'name':'Canned Food',
      'stat': 'Health'},
      {
      'name':'Crop Seeds',
      'stat': 'Health'
      },
      {
      'name':'Bandages',
      'stat': 'Health'},
      {
      'name':'Turtle Shell',
      'stat': 'Health'
      },
      {
      'name':'Dino Ribs',
      'stat': 'Health'},
      {
      'name':'Camp Fire',
      'stat': 'Health'
      }
      ]
  }
  const generateRandomCard = (e) => {
    const number = Math.floor(Math.random() * e);
    return number
  };

  const generateLuck = (e) => {
    let rarityCounts = {
      Common: 0,
      Rare: 0,
      Epic: 0,
      Legendary: 0,
    };
  
    let cardCounts = {
      Common: {},
      Rare: {},
      Epic: {},
      Legendary: {},
    };
  
    let AttackStat = 0;
    let HealthStat = 0;
  
    for (let i = 0; i < e; i++) {
      let chance = Math.random();
      let type = '';
      if (chance < 0.5) type = 'Common';
      else if (chance < 0.8) type = 'Rare';
      else if (chance < 0.95) type = 'Epic';
      else type = 'Legendary';
  
      rarityCounts[type] += 1;
      const typeIndex = generateRandomCard(cards[type].length);
      const card = cards[type][typeIndex];
  
      // Count card occurrences
      if (cardCounts[type][card.name]) {
        cardCounts[type][card.name].count += 1;
      } else {
        cardCounts[type][card.name] = {
          count: 1,
          stat: card.stat,
        };
      }
  
      if (card.stat === 'Attack') AttackStat += 1;
      else HealthStat += 1;
    }
  
    return { rarityCounts, cardCounts, AttackStat, HealthStat };
  };
  
  const formatResults = ({ rarityCounts, cardCounts, AttackStat, HealthStat }) => {
    const resultDisplay = [];
  
    Object.keys(cardCounts).forEach((rarity) => {
      if (rarityCounts[rarity] === 0) return;
  
      resultDisplay.push(
        <div key={rarity} className="mb-4">
          <h2 className="text-lg font-semibold underline mb-1">{rarity} ({rarityCounts[rarity]} cards)</h2>
          <div className="pl-4 space-y-1">
            {Object.entries(cardCounts[rarity]).map(([name, data]) => (
              <div key={name} className="text-sm">
                • {name} x{data.count} ({data.stat})
              </div>
            ))}
          </div>
        </div>
      );
    });
  
    resultDisplay.push(
      <div key="summary" className="mt-4 font-medium">
        Total: Attack Cards: {AttackStat} | Health Cards: {HealthStat}
      </div>
    );
  
    return resultDisplay;
  };
  

  return (
    <div className="p-4 border rounded-md shadow-md text-center">
      <h2 className="text-3xl font-semibold text-center mb-4">Test Your Luck!</h2>
      
      <div className="flex justify-center space-x-4 mb-4">
        <button
          onClick={() => {
            const data = generateLuck(10);
            setResults(formatResults(data));
          }}
          className="bg-green-500 text-white px-4 py-2 rounded-xl hover:bg-green-600 transition"
        >
          Generate 10 Cards 
        </button>
  
        <button
          onClick={() => {
            const data = generateLuck(50);
            setResults(formatResults(data));
          }}
          className="bg-green-500 text-white px-4 py-2 rounded-xl hover:bg-green-600 transition"
        >
          Generate 50 Cards 
        </button>

        <button 
          onClick={() => {
            const data = "";
            setResults(data);
          }}
          className="bg-gray-400 hover:bg-gray-500 text-white font-semibold py-2 px-4 rounded-xl"
        >Reset</button>
         
      </div>
  
      {results !== null && (
        <div className="mt-4 text-xl font-bold">{results}</div>
      )}
    </div>
  );
  
}